<template>
  <div class="industry">
    <Menu></Menu>
    <Tabber
      :tabberData="tabberData"
      :activeIndex="activeIndex"
      :tabTitle="tabTitle"
      @changeTabber="changeTabber"
    >
      <div slot="tabberContent" class="box" ref="tabberContent"></div>
    </Tabber>
  </div>
</template>
<script>
import { getBusinessList, getIndustry } from "@/api/manage";
import Menu from "../../components/menu/menu.vue";
import Tabber from "../../components/menu/tabber.vue";
export default {
  components: { Menu, Tabber },
  data() {
    return {
      tabberData: [],
      activeIndex: "1",
      tabTitle: "客户案例",
      listData: {},
      infoData: [],
    };
  },
  watch: {
    $route(to, from) {
      this.activeIndex = to.params.id;
      this.setInfo(this.activeIndex);
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getList();
    this.activeIndex = this.$route.params.id;
  },
  methods: {
    async getList() {
      let res = await getBusinessList({ pageNo: 1, pageSize: 999 });
      this.tabberData = [];
      res.data.map(item=>{
         let obj = {};
        obj.id = item.id;
        obj.name = item.busName;
        this.tabberData.push(obj);
      })
      
      this.infoData = [];
      let res1 = await getIndustry({ pageNo: 1, pageSize: 999, sortType: "a" });
      res1.data.forEach((item) => {
        res.data.map((item2) => {
          if (item.businessId == item2.id) {
            item.showName = item2.busName;
          }
        });
      });
      //去重
      let obj = {};
      let arr = JSON.parse(JSON.stringify(res1.data))
      res1.data = res1.data.reduce((item, next) => {
        console.log('1');
        if (!obj[next.businessId]) {
          obj[next.businessId] = true;
          item.push(next);
        }
        return item;
      }, []);
      console.log("res1.data", res1.data,arr);
      // res1.data.map((item) => {
      //   let obj = {};
      //   obj.id = item.businessId;
      //   obj.name = item.showName;
      //   this.tabberData.push(obj);
      // });
      this.infoData = arr;
      this.setInfo(this.activeIndex);
    },
    async changeTabber(index) {
      this.$router.push({ name: "industry", params: { id: index } });
    },
    async setInfo(index) {
    //  console.log("index", this.$refs["tabberContent"].innerHTML);
      this.$refs["tabberContent"].innerHTML = "";
      //let res = await getIndustry({ pageNo: 1, pageSize: 999 });
      //console.log('data',res);
      this.infoData.map((item) => {
        if (item.businessId == index) {
          let replaceTxt = 'http://116.206.94.117:8195//uploading'
          let newTxt = 'http://101.89.182.189:8191//uploading'
          let text =decodeURI(item.text).replace(new RegExp(replaceTxt,'g'),newTxt)
          this.$refs[
            "tabberContent"
          ].innerHTML += `<h2 style="text-align:center;font-size:1.14583rem;margin-bottom:1.458333rem">${item.title}</h2>`;
          this.$refs["tabberContent"].innerHTML += text+`<br/><br/><br/><br/>`;
        }
      });
    },
  },
};
</script>
<style scoped>
.title {
  font-size: 20px;
  color: #333;
  text-align: center;
}
.sketchTitle,
.featureTitle {
  font-size: 18px;
  color: #666;
  padding-bottom: 10px;
  font-weight: bold;
}
.sketchContent,
.feature p {
  font-size: 14px;
  color: #666;
  line-height: 28px;
  margin-bottom: 0;
}
.sketchContent {
  text-indent: 2em;
}
.sketchImg {
  margin: 60px 0;
  text-align: center;
}
.sketchImg img {
  height: auto;
  width: auto;
  max-width: 1100px;
}
.box {
  width: 1200px;
  margin: 0 auto;
}
</style>